<template>

    <div v-if="dataStore.infoWinOpen && type === 'IMAGE'" class="image-popup" v-on:click="clickOutside($event)">

        <div v-if="addopinion" class="window">

            <div>

                <form-pop-up
                    :slide="slide"
                    :parentslug="project.slug"
                    :index="index"
                ></form-pop-up>

            </div>

        </div>

        <div v-else>
            <current-opinion-window :index="index" :project="project" :slide="slide" ></current-opinion-window>
        </div>

    </div>

</template>

<script>

import { clickOutside } from '../../functions'

import dataStore from "../../store";

import FormPopUp from "./../layout/FormPopUp";

import currentOpinionWindow from "./../layout/currentOpinionWindow";

export default {

    data() {

        return {

            dataStore: dataStore,

            clickOutside,

            index : null,

            addopinion : null,

            slide : null,

            type : null,

            project : null

        };
    },

    components : {
        FormPopUp,
        currentOpinionWindow
    },

    mounted() {

        // type : 'IMAGE', // image / map
        // state : this.dataStore.infoWinOpen ? 'ADD' : 'VIEW',   // 'ADD' : 'VIEW'
        // addopinion : this.addopinion, // addopinion
        // slide : this.slide,// slide
        // project : this.project, // project
        // index : this.index // index

        document.addEventListener('eventOpenPopup', (e) => {

            const data = e.detail

            this.index = data.index

            this.addopinion = data.addopinion

            this.slide = data.slide

            this.type = data.type

            this.project = data.project
        })
    },

    methods: {

    }
};



</script>